export default __webpack_public_path__ + "static/media/free data.8d904f87.png";